const de = require('../translations/de')

const defaultState = {
  TRANSLATION: de.translation,
  CURRENTLANG: de.langKey,
}

export default defaultState
